// Guest types in display order; each is shown when its trip price allows it (`<key>_allowed`,
// adults unless explicitly false).
export const GUEST_TYPES = [{ key: "adults" }, { key: "children" }, { key: "infants" }, { key: "passengers" }]

export const getTotalGuests = (counts) => GUEST_TYPES.reduce((sum, { key }) => sum + Number(counts?.main?.[key] || 0), 0)

// Starting counts for a trip price: the minimum guest count on the first allowed type (as the old
// widget does), so the price summary shows straight away.
export const buildInitialCounts = (priceData, minGuests) => {
  const firstAllowed =
    GUEST_TYPES.find(({ key }) => (key === "adults" ? priceData?.adults_allowed !== false : !!priceData?.[`${key}_allowed`]))?.key || "adults"
  const main = GUEST_TYPES.reduce((acc, { key }) => ({ ...acc, [key]: key === firstAllowed ? minGuests || 0 : 0 }), {})
  return { main, extra: { adults: 0, children: 0, infants: 0, passengers: 0 } }
}
